import { render, staticRenderFns } from "./LazyLoadDirective.vue?vue&type=template&id=bd2b3f2c&scoped=true&"
import script from "./LazyLoadDirective.vue?vue&type=script&lang=js&"
export * from "./LazyLoadDirective.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2b3f2c",
  null
  
)

export default component.exports